<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست احراز هویت ها" color="accent">
			<template #topActions>
				<div class="d-flex">
					<export-excel :items="filteredItems" :headers="headers" :fileName="excelFileName">
					</export-excel>
				</div>
			</template>
			<div class="pa-5 pt-0">
				<v-row>
					<v-col cols="12" md="12" class="d-flex align-center justify-center">
						<date-navigator v-model="dateRange" :options="{ rangeMode: true }">
							<div class="text-center">
								<v-btn color="primary" dark small class="mx-1" @click="loadData" :loading="loading">
									دریافت اطلاعات
								</v-btn>
							</div>
						</date-navigator>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" v-if="filterStatuses.length">
						<span class="ml-2">فیلتر وضعیت:</span>
						<v-btn-toggle v-model="statusFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
							<v-btn v-for="status in filterStatuses" :key="status" :value="status" small>
								{{ status }}
								<v-badge color="blue" :content="status === 'همه' ? items.length : items.filter(x => x.status_Text == status).length || '0'" inline>
								</v-badge>
							</v-btn>
						</v-btn-toggle>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</v-col>
					<v-col cols="12">
						<v-data-table :height="dataTableFixedHeight - 100" fixed-header :loading="loading" :headers="headers" :items="filteredItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td>
										<div><small>{{ row.item.memberFullName }}</small></div>
										<div class="d-flex">
											<small class="grey--text">کد ملی: {{ row.item.memberNationalCode }}</small>
										</div>
									</td>
									<td>
										<div><small>{{ row.item.authorizationItemTitle }}</small></div>
									</td>
									<td class="text-center">
										<small>&lrm;{{ `${row.item.createDate_Persian.date} ${row.item.createDate_Persian.time}` }}</small>
									</td>
									<td class="text-center">
										<small>{{ row.item.status_Text }}</small>
									</td>
									<td class="text-center">
										<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
											<v-icon dark>
												mdi-square-edit-outline
											</v-icon>
										</v-btn>
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</div>
		</material-card>

		<confirm-dlg ref="confirm" />

		<div class="py-3" />

		<MemberAuthorizationManager v-if="dialogAuthorizationManager && selectedItem" area="admin" :member="{ id: selectedItem.memberId, fullName: selectedItem.memberFullName, nationalCode: selectedItem.memberNationalCode }" type="managerDialog" :filterId="selectedItem.id" @callbck="callbck" />

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import ManageLoan from '@/views/admin/ManageLoan.vue'
	import { sponsorStatuses } from '@/util/enums'

	export default {
		name: 'MemberAuthorizations',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'MemberAuthorizationManager': () => import('@/components/memberAuthorization/MemberAuthorizationManager.vue'),
		},
		data() {
			return {
				errorMessages: '',
				selectedItem: null,
				dialogAuthorizationManager: false,
				search: '',
				dateRange: { start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toJSON(), end: '' },
				headers: [
					{
						text: 'نام مشتری',
						align: 'start',
						sortable: true,
						value: 'memberFullName',
						width: 270
					},
					{
						text: 'کد ملی',
						align: 'start d-none',
						sortable: true,
						value: 'memberNationalCode',
					},
					{
						text: 'گام احراز',
						align: 'start',
						sortable: true,
						value: 'authorizationItemTitle',
					},
					{
						text: 'تاریخ ثبت',
						align: 'center',
						sortable: true,
						value: 'createDate_Persian',
						excel_value: '%root%',
						excel_callback: (value) => {
							let text = value.createDate_Persian?.date || 'نامشخص'
							return text
						}
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status_Text',
						width: 90
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				items: [],
				filterStatuses: [],
				statusFilter: 'همه',
				loading: false,
				routeStatusFilter: '',
			}
		},
		mounted() {
			this.routeStatusFilter = this.$route.params.statusFilter || ''
			this.loadData()
		},
		computed: {
			excelFileName() {
				let name = 'لیست احراز هویت ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.endDate)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			},
			filteredItems() {
				if (this.statusFilter === 'همه')
					return this.items

				return this.items.filter(x => x.status_Text === this.statusFilter)
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/MemberAuthorizationItem/list?start=' + this.dateRange.start + '&end=' + this.dateRange.end, null)
					.then(response => {
						this.items = response
						this.filterStatuses = [...new Set(response.map(x => x.status_Text))]
						if (this.routeStatusFilter) {
							if (!this.filterStatuses.includes(this.routeStatusFilter))
								this.filterStatuses.splice(0, 0, this.routeStatusFilter)
							this.statusFilter = this.routeStatusFilter
						}
						if (this.filterStatuses.length)
							this.filterStatuses.push('همه')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			edit(item) {
				this.selectedItem = item
				this.dialogAuthorizationManager = false
				setTimeout(() => {
					this.dialogAuthorizationManager = true
				}, 100)
			},
			callbck(result) {
				// this.dialog = false
				if (result === 'updated') {
					this.loadData()
				}
			},
		},
	}
</script>
<style></style>
